export const UPDATE_SEARCH_TERM = 'UPDATE_SEARCH_TERM';
export const UPDATE_STARTS_WITH = 'UPDATE_STARTS_WITH';
export const UPDATE_DYNAMIC_FILTER = 'UPDATE_DYNAMIC_FILTER';
export const SET_DYNAMIC_FILTERS = 'SET_DYNAMIC_FILTERS';
export const INIT_FILTER_STATE = 'INIT_FILTER_STATE';

export const CLEAR_ALL_FILTERS = 'CLEAR_ALL_FILTERS';

export const SET_ACTIVE_PAGE = 'SET_ACTIVE_PAGE';
export const RESET_ACTIVE_PAGE = 'RESET_ACTIVE_PAGE';
